import { app } from '../app';

class EpmAccountResource {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    getEpmSsoInstructions(applicationId, accountId) {
        const url = `app/rest/epm/account/sso-instructions/${applicationId}/${accountId}`;
        return this.$http.get(url).then(({data}) => data);
    }

    getEpmTracker(applicationId, accountId) {
        const url = `app/rest/epm/account/tracker/${applicationId}/${accountId}`;
        return this.$http.get(url, {transformResponse}).then(({data}) => data);

        // fixme: this is a workaround. response body should contain valid json.
        function transformResponse(data) {
            try {
                // response.data.message is available when the request fails
                return JSON.parse(data)
            } catch (e) {
                // success response is a bare string which cannot be parsed as json
                return data;
            }
        }
    }
}

app.service('EpmAccountResource', EpmAccountResource);



// WEBPACK FOOTER //
// ./src/portal/rest/EpmAccountResource.js